import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4c558e23"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Confirmar Seleção", -1))
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = { class: "ant-row" }
const _hoisted_4 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { key: 2 }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icone = _resolveComponent("icone")!
  const _component_mensagem_sem_dados = _resolveComponent("mensagem-sem-dados")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_card = _resolveComponent("card")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    keyboard: false,
    visible: _ctx.modalBase.computedVisivel,
    "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.modalBase.computedVisivel) = $event)),
    centered: "",
    width: 1300,
    "wrap-class-name": "ss-modal-cadastros",
    title: 'Validar Pedidos de Compra',
    maskClosable: false
  }, {
    closeIcon: _withCtx(() => [
      _createVNode(_component_icone, { nome: "voltar" })
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", null, [
        _createElementVNode("button", {
          type: "button",
          class: "ant-btn ant-btn-lg ant-btn-primary ss-btn-acao-destaque",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.confirmar && _ctx.confirmar(...args)))
        }, _hoisted_2)
      ])
    ]),
    default: _withCtx(() => [
      (_openBlock(), _createElementBlock("div", {
        key: _ctx.props.empresa
      }, [
        _createVNode(_component_a_form, { layout: "vertical" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_card, { titulo: "Pedidos de Compras" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_table, {
                      class: "ss-grade",
                      columns: _ctx.state.colunas.filter(item => item.visible),
                      "data-source": _ctx.state.pedidosCompra,
                      rowKey: "codigo",
                      pagination: false,
                      loading: _ctx.telaBase.carregando,
                      scroll: { y: _ctx.state.windowHeight },
                      size: "small",
                      "row-class-name": _ctx.rowClassName,
                      "row-selection": {
                  selectedRowKeys: _ctx.state.codigosSelecionados,
                  onChange: _ctx.onChange,
                  onSelect: _ctx.onSelect
                },
                      onRow: _ctx.onRowClick
                    }, {
                      bodyCell: _withCtx(({ text, column }) => [
                        (column.customRenderRow === _ctx.ECustomRenderRow.MascararFracionado)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.UtilitarioMascara.mascararValor(text)), 1))
                          : (column.customRenderRow === _ctx.ECustomRenderRow.MascararData)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.UtilitarioData.aplicaFormatoData(text)), 1))
                            : (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(text), 1))
                      ]),
                      emptyText: _withCtx(() => [
                        _createVNode(_component_mensagem_sem_dados, {
                          resultadoPesquisa: !_ctx.telaBase.carregando,
                          mensagem: _ctx.telaBase.carregando ? 'Buscando informações, por favor aguarde...' : 'Nenhum produto encontrado...'
                        }, null, 8, ["resultadoPesquisa", "mensagem"])
                      ]),
                      _: 1
                    }, 8, ["columns", "data-source", "loading", "scroll", "row-class-name", "row-selection", "onRow"])
                  ]),
                  _: 1
                }),
                (_ctx.state.indexPedidoSelecionado > -1 && _ctx.UtilitarioGeral.validaLista(_ctx.state.pedidosCompra[_ctx.state.indexPedidoSelecionado].itens))
                  ? (_openBlock(), _createBlock(_component_card, {
                      key: 0,
                      titulo: "Itens do Pedido de Compra"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_table, {
                          columns: _ctx.state.colunasProdutos.filter(item => item.visible),
                          "data-source": _ctx.state.pedidosCompra[_ctx.state.indexPedidoSelecionado].itens,
                          rowKey: "codigo",
                          pagination: false,
                          scroll: { y: _ctx.state.windowHeight },
                          size: "small"
                        }, {
                          bodyCell: _withCtx(({ text, column }) => [
                            (column.customRenderRow === _ctx.ECustomRenderRow.MascararFracionado)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.UtilitarioMascara.mascararValor(text)), 1))
                              : (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(text), 1))
                          ]),
                          emptyText: _withCtx(() => [
                            _createVNode(_component_mensagem_sem_dados, {
                              resultadoPesquisa: !_ctx.telaBase.carregando,
                              mensagem: _ctx.telaBase.carregando ? 'Buscando informações, por favor aguarde...' : 'Nenhum registro foi encontrado!'
                            }, null, 8, ["resultadoPesquisa", "mensagem"])
                          ]),
                          _: 1
                        }, 8, ["columns", "data-source", "scroll"])
                      ]),
                      _: 1
                    }))
                  : (_ctx.state.indexPedidoSelecionado > -1)
                    ? (_openBlock(), _createBlock(_component_card, { key: 1 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_mensagem_sem_dados, { mensagem: "Nenhum Produto disponível" })
                        ]),
                        _: 1
                      }))
                    : (_openBlock(), _createBlock(_component_card, { key: 2 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_mensagem_sem_dados, { mensagem: "Nenhum produto selecionado" })
                        ]),
                        _: 1
                      }))
              ])
            ])
          ]),
          _: 1
        })
      ]))
    ]),
    _: 1
  }, 8, ["visible"]))
}